import { useApplicantHelpers } from "@Client/@Composables/application-standalone/pages/applicants/useApplicantHelpers";
import { useAssetHelpers } from "@Client/@Composables/application-standalone/pages/assets/useAssetHelpers";
import SectionTitle from "@Client/@Modules/application-standalone/components/helpers/section-title.vue";
import PageSummarySectionGroupLayout from "@Client/@Modules/application-standalone/components/layout/page-summary-section-group-layout.vue";
import { defineComponent, computed, onMounted, ref, watch } from "@vue/composition-api";
import { useSummaryHelpers } from "@Client/@Composables/application-standalone/pages/summary/useSummaryHelpers";
import { useValidatorsHelper } from "@Client/@Composables/application-standalone/validations/useValidatorsHelper";
import ApplicationSectionErrorIcon from "@Client/@Modules/application-standalone/components/helpers/application-section-error-icon.vue";
import { ordinalIndex } from "@Shared/@Utils/helpers/text";
import RemoveComponentModal from "./../remove-component-modal.vue";
import { useI18n } from "vue-i18n-composable";
export default defineComponent({
  name: "AssetSummary",
  components: {
    PageSummarySectionGroupLayout,
    SectionTitle,
    ApplicationSectionErrorIcon,
    RemoveComponentModal
  },
  props: {
    showErrors: {
      type: Number,
      default: 0
    }
  },
  setup(props, {
    emit
  }) {
    const invalidAssets = ref([]);
    const {
      t
    } = useI18n();
    const {
      allApplicants,
      applicantNameFromIndex,
      isApplicantVisibleFromFillOut
    } = useApplicantHelpers();
    const {
      addEmptyAsset,
      deleteAsset,
      applicantHasAssets,
      isAssetSectionVisibleForMainApplicant,
      isAssetSectionVisibleForCoApplicants
    } = useAssetHelpers();
    const {
      getTextForAddButton,
      editButtonText,
      allowEdit
    } = useSummaryHelpers();
    const {
      getInvalidAssets
    } = useValidatorsHelper();
    const addAssetButtonText = applicant => {
      return getTextForAddButton("application-standalone.pages.assets.addAsset", {
        iteratee: applicantHasAssets,
        singleValue: applicant["assets"]
      });
    };
    onMounted(() => {
      updateInvalidAssets();
    });
    const updateInvalidAssets = async () => {
      invalidAssets.value = await getInvalidAssets();
    };
    const areInvalidAssets = computed(() => !!invalidAssets.value.length);
    watch(areInvalidAssets, newValue => emit("disable-save", newValue), {
      immediate: true
    });
    const handleAddAsset = appIndex => {
      const applicantIndex = appIndex != null ? appIndex : 0;
      addEmptyAsset(applicantIndex);
      const applicant = allApplicants.value[applicantIndex];
      if (!applicant) return;
      handleNavigation(applicantIndex, applicant.assets.length - 1);
    };
    const handleNavigation = (applicantIndex, assetIndex, applicantId = "") => {
      emit("navigate", {
        applicantIndex,
        assetIndex,
        applicantId
      });
    };
    const isSectionVisibleToApplicant = (applicantIndex, applicantId) => {
      const visibleFromSchema = applicantIndex === 0 ? isAssetSectionVisibleForMainApplicant.value : isAssetSectionVisibleForCoApplicants.value;
      const visibleFromFillOut = isApplicantVisibleFromFillOut(applicantId);
      return visibleFromSchema && visibleFromFillOut;
    };
    const isInvalid = (applicantIdx, index) => {
      return invalidAssets.value.some(({
        assetIndex,
        applicantIndex
      }) => applicantIdx == applicantIndex && assetIndex === index);
    };
    const firstErrorId = computed(() => {
      var _invalidAssets$value$, _invalidAssets$value, _invalidAssets$value$2;
      return (_invalidAssets$value$ = (_invalidAssets$value = invalidAssets.value) == null ? void 0 : (_invalidAssets$value$2 = _invalidAssets$value[0]) == null ? void 0 : _invalidAssets$value$2.assetIndex) != null ? _invalidAssets$value$ : null;
    });
    const handleDelete = ({
      applicantIndex,
      assetIndex
    }) => {
      deleteAsset(applicantIndex, assetIndex);
      emit("save");
      updateInvalidAssets();
    };
    const modalText = computed(() => {
      return t("application-form.removeComponentModalMessage", {
        componentType: "asset"
      });
    });
    const removeComponentModal = ref();
    const openDeletionModal = data => {
      var _removeComponentModal;
      removeComponentModal == null ? void 0 : (_removeComponentModal = removeComponentModal.value) == null ? void 0 : _removeComponentModal.openModal(data);
    };
    return {
      handleAddAsset,
      allApplicants,
      applicantNameFromIndex,
      handleNavigation,
      deleteAsset,
      addAssetButtonText,
      editButtonText,
      allowEdit,
      isSectionVisibleToApplicant,
      isInvalid,
      invalidAssets,
      firstErrorId,
      handleDelete,
      applicantHasAssets,
      ordinalIndex,
      updateInvalidAssets,
      modalText,
      removeComponentModal,
      openDeletionModal
    };
  }
});